import dayjs from "dayjs";

export const dayjsUTC = (date: string | null, format = "YYYY-MM-DD") => {
  let tmp = null;

  if (typeof date === "string" && date.charAt(date.length - 1) === "Z") {
    tmp = new Date(date.substring(0, date.length - 1));
  } else {
    tmp = date;
  }

  return dayjs(tmp).format(format);
};
